import _ from 'lodash';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import { VehicleTypeEnum } from '../../../../scripts/core/vehicleType/constants';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class MallCentersFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const data = [];

        if (!this.options.fields) {
            return data;
        }

        if (this.options.fields.segments) {
            data.push({
                name: 'segments',
                position: 1,
                visible: isAuthorized(FeaturePermission.LAYER_MALL_CENTERS.filterSegment),
                fields: [{
                    title: translate('Common.Segments'),
                    name: 'models',
                    dataSource: _.map(environment.get('CONFIG.FILTERS.SEGMENT'), val => ({
                        text: translateText(val.name, true),
                        value: val.id
                    })),
                    value: 'value',
                    text: 'text',
                    type: 'multiselect',
                    skipAll: true
                }]
            });
        }

        if (this.options.fields.brands) {
            if (_.isObject(this.options.fields.brands) && !this.options.fields.brands.visible) {
                return data;
            }

            const filter = {
                name: 'category_and_brands',
                data: environment.get('CONFIG.FILTERS.BRANDS'),
                position: 2,
                visible: isAuthorized(FeaturePermission.LAYER_MALL_CENTERS.filterBrand),
                fields: [{
                    title: translate('Common.Brand'),
                    name: 'brands',
                    value: 'brand',
                    text: 'brand',
                    type: 'multiselect'
                }]
            };

            if (environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Car) {
                filter.fields.unshift({
                    title: `${translate('Common.Classification')} ${translate('Common.Brand')}`,
                    name: 'classification',
                    value: 'classificationId',
                    text: 'classification',
                    skipAll: true,
                    type: 'multiselect'
                });
            }

            data.push(filter);
        }
        if (this.options.fields.groups) {
            data.push({
                name: 'group',
                position: 4,
                visible: isAuthorized(FeaturePermission.LAYER_MALL_CENTERS.filterGroup),
                fields: [{
                    title: translate('Common.Group'),
                    name: 'group',
                    dataSource: _(environment.get('CONFIG.FILTERS.GROUPS_NAME'))
                        .orderBy(val => val.text)
                        .value(),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (this.options.fields.fuelTypes) {
            data.push({
                name: 'fuelTypes',
                position: 5,
                visible: isAuthorized(FeaturePermission.LAYER_MALL_CENTERS.filterFuelType),
                fields: [{
                  title: translate('Common.FuelType'),
                  name: 'fuelTypes',
                  dataSource: _.map(environment.get('CONFIG.FILTERS.FUEL_TYPES'), (fuel) => ({ text: fuel.text, value: fuel.value })),
                  value: 'value',
                  text: 'text',
                  skipAll: true,
                  type: 'multiselect'
                }]
              });
        }

        if (environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT')
            && environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT').length) {
            data.push({
                name: 'industry',
                position: 6,
                visible: true,
                fields: [{
                    title: translate('Common.Industry'),
                    name: 'industry',
                    dataSource: environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT'),
                    value: 'id',
                    text: 'name',
                    type: 'dropdown'
                }]
            });
        }

        if (_.size(environment.get('CONFIG.STATES')) > 1) {
            data.push({
                name: 'state',
                visible: true,
                fields: [{
                    title: translate('Common.State'),
                    name: 'state',
                    dataSource: environment.get('CONFIG.STATES'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (_.size(environment.get('CONFIG.FILTERS.MALL_CENTERS_HAVE_STORES')) > 1) {
            data.push({
                name: 'mallCenters',
                visible: true,
                fields: [{
                    title: translate('Common.MallCenters'),
                    name: 'mallCenters',
                    dataSource: environment.get('CONFIG.FILTERS.MALL_CENTERS_HAVE_STORES'),
                    value: 'idMall',
                    text: 'nameMall',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/mallCenters.factory.js